import { type ReactElement } from 'react'
import { NotificationViewSchema, type NotificationView } from '@terros/common'
import { SegmentedControl } from '@mantine/core'

export function NotificationViews({
  view,
  onChange,
}: {
  view: NotificationView
  onChange: (view: NotificationView) => void
}): ReactElement {
  return (
    <SegmentedControl
      size='xs'
      aria-label='Notification view'
      value={view}
      onChange={(value) => onChange(NotificationViewSchema.parse(value))}
      data={[
        { value: 'inbox', label: 'Inbox' },
        { value: 'unread', label: 'Unread' },
        { value: 'archived', label: 'Archived' },
      ]}
    />
  )
}
